export enum STATUS_TYPE {
    N = 'NEW',
    CAN = 'CANCEL',
    UN_PD = 'UN-PAID',
    COM = 'COMPLETED',
    booking = 'BOOKED',
    PR = 'ON-PROGRESS',
    Started = 'STARTED',
}